export const isExternalLink = (path, target) =>
  /^(https?:\/\/|www\.|mailto:|tel:|sms:)/i.test(path) || target === 'blank';
